export default __webpack_public_path__ + "static/media/DJI_0895.MP4.00_00_46_13.Still006.9af6ee7f.jpg";